import { App, Component } from "vue";
import CollapseVue from "./Layout/Collapse.vue";
import TabsVue from "./Layout/Tabs.vue";
import Grids from "./Layout/Grids.vue";
import Card from "./Layout/Card.vue";

import PcTextField from "./Fields/TextField/PcTextField.vue";
import PcNumericField from "./Fields/NumericField/PcNumericField.vue";
import PcMultTextField from "./Fields/MultTextField/PcMultTextField.vue";
import PcBooleanField from "./Fields/BooleanField/PcBooleanField.vue";
import PcDateField from "./Fields/DateField/PcDateField.vue"
import PcSingleChoiceProField from "./Fields/SingleChoiceProField/PcSingleChoiceProField.vue";
import PcMultChoiceProField from "./Fields/MultChoiceProField/PcMultChoiceProField.vue";
import DescriptionField from "./Fields/DescriptionField/DescriptionField.vue";
import PcFrameField from "./Fields/FrameField/PcFrameField.vue";
import PcSignField from "./Fields/SignField/PcSignField.vue";
import PcAttachFileField from "./Fields/AttachFileField/PcAttachFileField.vue";
import PcImageField from "./Fields/ImageField/PcImageField.vue"
import PcPositonField from "./Fields/PositionField/PcPositonField.vue";
import PcSingleDepartField from "./Fields/SingleDepartField/PcSingleDepartField.vue"
import PcDepartField from "./Fields/DepartField/PcDepartField.vue";
import PcLinkQueryField from "./Fields/LinkQueryField/PcLinkQueryField.vue";
import PcHtmlField from "./Fields/HtmlField/PcHtmlField.vue"
import PcButtonField from "./Fields/ButtonField/PcButtonField.vue";
import PrimaryKeyField from "./Fields/PrimaryKeyField/PrimaryKeyField.vue";
import PcComputedObjectField from "./Fields/ComputedObejctField/PcComputedObjectField.vue";
import PcSubFormField from "./Fields/SubFormField/PcSubFormField.vue";
import PcCorrelationField from "./Fields/CorrelationField/PcCorrelationField.vue";
import PcContentPickerField from "./Fields/ContentPickerField/PcContentPickerField.vue"
import PcSingleUserField from "./Fields/SingleUserField/PcSingleUserField.vue"
import PcUserField from "./Fields/UserField/PcUserField.vue"
import PcLinkContentItemField from "./Fields/LinkContentItemField/PcLinkContentItemField.vue"
import PcHasOneField from "./Fields/HasOneField/PcHasOneField.vue";

import PcPhoneField from "./Fields/PhoneField/PhoneField.vue"

let components = [
    CollapseVue,
    TabsVue,
    Grids,
    Card,

    PcTextField,
    PcMultTextField,
    PcBooleanField,
    PcNumericField,
    PcDateField,
    PcSingleChoiceProField,
    PcMultChoiceProField,
    PcFrameField,
    DescriptionField,
    PcSignField,
    PcAttachFileField,
    PcImageField,
    PcPositonField,
    PcSingleDepartField,
    PcDepartField,
    PcLinkQueryField,
    PcHtmlField,
    PcButtonField,
    PrimaryKeyField,
    PcComputedObjectField,
    PcSubFormField,
    PcCorrelationField,
    PcContentPickerField,
    PcSingleUserField,
    PcUserField,

    PcPhoneField,
    PcLinkContentItemField,
    PcHasOneField
]

export default function useFields(app: App) {
    // 注册组件
    components.forEach((component: Component) => {
       app.component(component.name ?? "", component);
    });
}